module.exports = __webpack_public_path__ + "static/media/buildings.28fa5440.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/buildings.png
// module id = 38
// module chunks = 0